import { trackEvent } from 'helpers/analytics';
import { BoostIcon } from './components/BoostIcon';

/**
 * Resolve AI application boost state + primary action for a job (shared by table cell and row menu).
 */
export const getJobBoostStatus = (currentJob, onLaunchApplicationBoostAgent) => {
  const jobBoostStatuses = [
    {
      id: 'not_boosted',
      label: 'Not boosted',
      background: 'neutral.20',
      actionText: 'Boost job',
      action: (job) => {
        trackEvent('application_boost:boost_job_click');
        onLaunchApplicationBoostAgent({ view: 'launch', job });
      },
    },
    {
      id: 'ready_to_launch',
      label: 'Ready to launch',
      color: 'blue.700',
      background: '#EDF0FD',
      actionText: 'Open agent',
      action: (job) => {
        trackEvent('application_boost:open_boost_agent', {
          agent: 'application_boost',
        });
        onLaunchApplicationBoostAgent({ view: 'boost', job });
      },
    },
    {
      id: 'needs_calibration',
      label: 'Needs calibration',
      color: 'blue.700',
      background: '#EDF0FD',
      actionText: 'Calibrate',
      action: (job) => {
        trackEvent('application_boost:open_boost_agent', {
          agent: 'calibration-selection',
        });
        onLaunchApplicationBoostAgent({ view: 'calibration-selection', job });
      },
    },
    {
      id: 'calibrating',
      label: 'Preparing boost',
      color: 'text.main',
      background: 'neutral.100',
      actionText: null,
      action: null,
      tooltip: "We're getting ready to boost your job. It'll be ready in a few minutes.",
    },
    {
      id: 'in_progress',
      label: 'In progress',
      icon: BoostIcon,
      color: '',
      background: 'purple.100',
      actionText: 'Open agent',
      sx: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        gap: '8px',
        borderRadius: '4px',
        background:
          'linear-gradient(78deg, rgba(73, 0, 255, 0.08) 0%, rgba(212, 0, 255, 0.08) 50%, rgba(255, 146, 87, 0.08) 90%, rgba(73, 0, 255, 0.08) 100%), #FFF',
        backgroundSize: '200% 200%',
        animation: 'gradient 2.5s ease-in infinite',
        px: '8px',
        height: '24px',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: '4px',
          padding: '1px',
          background: 'linear-gradient(78deg, #4900FF 0%, #D400FF 50%, #FF9257 90%, #4900FF 100%), #FFF',
          backgroundSize: '200% 200%',
          animation: 'gradient 2.5s ease-in infinite',
          mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude',
          overflow: 'hidden',
        },
        '@keyframes gradient': {
          '0%': {
            backgroundPosition: '200% 50%',
          },
          '100%': {
            backgroundPosition: '0% 50%',
          },
        },
      },
      action: (job) => {
        trackEvent('application_boost:open_boost_agent_click', {
          agent: 'application_boost',
        });
        onLaunchApplicationBoostAgent({ view: 'boost', job });
      },
    },
    {
      id: 'finished',
      label: 'Completed',
      color: 'green.700',
      background: 'green.20',
      actionText: 'Open agent',
      action: (job) => {
        onLaunchApplicationBoostAgent({ view: 'boost', job });
      },
    },
  ];
  return jobBoostStatuses.find((status) => status.id === currentJob.sourcingCampaign?.status) ?? jobBoostStatuses[0];
};
